import { render, staticRenderFns } from "./Trivia2.vue?vue&type=template&id=0e2e4ff0&scoped=true&"
import script from "./Trivia2.vue?vue&type=script&lang=js&"
export * from "./Trivia2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e4ff0",
  null
  
)

export default component.exports